import Container from "react-retool";
import { useLocation } from "react-router-dom";

import {
  useConnection,
  useConnections,
  useRetoolEmbed,
} from "src/api/connectApi/queries";
import { RetoolEmbedResponse } from "src/api/connectApi/types";
import { useWorkspace } from "src/api/queries";
import { LoadingView } from "src/base-components/LoadingView";
import { LayoutHeader } from "src/layout/Header";
import { useWorkspaceContext } from "src/router/routerContextHooks";
import {
  DashboardPageParams,
  getRetoolUrl,
  getUrlToRetoolPage,
} from "src/router/urls";
import { useUserData } from "src/store/AuthStore";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const useRetoolInformation = () => {
  const { wsId, orgId } = useParamsDecode<DashboardPageParams>();
  const { workspace } = useWorkspaceContext();

  const connections = useConnections(workspace.base_url);
  const retoolConnection = connections.data?.find(
    (c) => c.provider === "retool",
  );
  const location = useLocation();

  const retoolPageUrl = getUrlToRetoolPage(orgId, wsId, retoolConnection?.id);
  const isCurrentPageRetool =
    `${location.pathname}${location.search}` === `${retoolPageUrl}`;
  return { retoolPageUrl, retoolConnection, isCurrentPageRetool };
};

export const Retool: React.FC<{ wsId: string }> = ({ wsId }) => {
  const { retool_id, orgId } = useParamsDecode<{
    retool_id: string;
    orgId: string;
  }>();
  const workspace = useWorkspace(wsId);
  const { signed_in_user_id, signed_in_email } = useUserData();
  const connection = useConnection({
    baseUrl: workspace.data?.base_url,
    id: retool_id,
  });
  const retoolEmbed = useRetoolEmbed(
    workspace.data?.base_url,
    connection.data,
    signed_in_user_id,
    signed_in_email,
  );
  const height = window.innerHeight - 52;
  return (
    <div className="w-screen bg-gray-100">
      <LayoutHeader
        breadcrumbs={[
          {
            key: "retool",
            breadcrumb: connection.data && (
              <LayoutHeader.Breadcrumb
                href={getRetoolUrl(orgId, wsId, connection.data.id)}
                label={connection.data.name}
              />
            ),
          },
        ]}
      />
      <div>
        <LoadingView
          queryResult={retoolEmbed}
          renderUpdated={(retool: RetoolEmbedResponse) => (
            <Container
              key={retool.data.embed_url} // force re-mount when embed_url changes
              height={height}
              url={retool.data.embed_url}
            />
          )}
        />
      </div>
    </div>
  );
};
